import { EstateRagDocumentSourceTypeKey } from '@/modules/ai/constants/EstateRagDocumentSourceTypeKey';
import Enum from '@/modules/core/app/helpers/Enum';
import notionIcon from '@/assets/illustrations/notion-logo.svg';
import legalReasoningIcon from '@/assets/illustrations/legal-scale.svg';
import contentLibraryIcon from '@/assets/illustrations/database-document.svg';
import internetResourceIcon from '@/assets/illustrations/internet-resource.svg';
import Lang from '@/modules/core/app/services/Lang';

export class EstateRagDocumentSourceType extends Enum {
  key!: EstateRagDocumentSourceTypeKey;
  value!: string;
  icon?: string;

  static NOTION: EstateRagDocumentSourceType = {
    key: EstateRagDocumentSourceTypeKey.NOTION,
    get value() {
      return Lang.t('ai.notion');
    },
    icon: notionIcon
  };

  static LEGAL_REASONING: EstateRagDocumentSourceType = {
    key: EstateRagDocumentSourceTypeKey.LEGAL_REASONING,
    get value() {
      return Lang.t('ai.legal-reasoning');
    },
    icon: legalReasoningIcon
  };

  static CONTENT_LIBRARY: EstateRagDocumentSourceType = {
    key: EstateRagDocumentSourceTypeKey.CONTENT_LIBRARY,
    get value() {
      return Lang.t('ai.content-library');
    },
    icon: contentLibraryIcon
  };

  static ESTATE_LAW: EstateRagDocumentSourceType = {
    key: EstateRagDocumentSourceTypeKey.ESTATE_LAW,
    get value() {
      return Lang.t('ai.estate-law-capitalized');
    },
    icon: legalReasoningIcon
  };

  static INTERNET_RESOURCE = {
    key: EstateRagDocumentSourceTypeKey.INTERNET_RESOURCE,
    get value(): string {
      return Lang.t('ai.public-domain');
    },
    icon: internetResourceIcon
  };
}
